import { itemTypeApi } from "../../api";

const ItemTypeService = {
  fetchDropdown: async () => {
    const response = await itemTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default ItemTypeService;
